export const common = {
  // Navbar
  nav: {
    home: 'Startseite',
    why: 'Warum',
    applications: 'Anwendungen',
    products: 'Produkte',
    resources: 'Ressourcen',
    contacts: 'Kontakte',
    askAI: 'KI fragen',
    myths: 'Mythen vs Fakten',
    o3101: 'O₃ 101',
    safety: 'Sicherheit',
    faq: 'FAQ',
    blog: 'Blog',
  },
  
  // Hero
  hero: {
    badge: 'Bildungs-Hub • Sicherheit zuerst • Öko-Tech',
    titleA: 'OzoneFusion 2.0 — Ozon gut erklärt. Besser genutzt.',
    titleB: 'Sicherheit, Klarheit, Technologie. Willkommen im Ozon-Hub.',
    titleC: 'O₃ ohne Verwirrung: Schnellanleitungen, FAQ, Ressourcen und KI-Assistent.',
    subtitle: 'Ozon verstehen. Sicher verwenden.',
    cta1: 'O₃ 101 entdecken',
    cta2: 'Sicherheitsleitfaden',
  },
  
  // Why Section
  why: {
    title: 'Warum ein Bildungs-Hub',
    subtitle: 'Klare Informationen, garantierte Sicherheit, Nachhaltigkeit im Mittelpunkt',
    clarity: {
      title: 'Klarheit',
      description: 'Wissenschaftliche Informationen für alle zugänglich, ohne unnötigen Fachjargon.',
    },
    safety: {
      title: 'Sicherheit',
      description: 'Geprüfte Protokolle und Richtlinien für verantwortungsvollen Ozongebrauch.',
    },
    sustainability: {
      title: 'Nachhaltigkeit',
      description: 'Umweltfreundliche Technologie, die Umwelt und Gesundheit respektiert.',
    },
  },
  
  // Myths vs Facts
  myths: {
    title: 'Mythen vs Fakten',
    subtitle: 'Häufige Missverständnisse über Ozon aufklären',
    myth1: 'Es ist immer gefährlich',
    fact1: 'Es hängt von Dosis, Zeit, Belüftung und Verfahren ab',
    myth2: 'Es ist Magie',
    fact2: 'Es ist Chemie: kraftvoll, wenn richtig gehandhabt',
    myth3: 'Es beschädigt alles',
    fact3: 'Kompatibel mit den meisten Materialien bei richtiger Anwendung',
    myth4: 'Keine Belüftung nötig',
    fact4: 'Belüftung ist für die Sicherheit unerlässlich',
  },
  
  // Safety
  safety: {
    title: 'Sicherheit zuerst',
    subtitle: 'Die 6 goldenen Regeln für verantwortungsvollen Gebrauch',
    rule1: {
      title: 'Belüftung',
      description: 'Lüften Sie Räume nach der Behandlung immer',
    },
    rule2: {
      title: 'Richtige Zeiten',
      description: 'Befolgen Sie empfohlene Expositionszeiten',
    },
    rule3: {
      title: 'Konzentrationen',
      description: 'Verwenden Sie angemessene Dosen für jede Anwendung',
    },
    rule4: {
      title: 'Kinder und Haustiere',
      description: 'Halten Sie sie während und nach der Behandlung fern',
    },
    rule5: {
      title: 'Kompatible Materialien',
      description: 'Prüfen Sie Kompatibilität mit Gummi und Kunststoffen',
    },
    rule6: {
      title: 'Wartung',
      description: 'Überprüfen Sie Ihr Gerät regelmäßig',
    },
  },
  
  // Applications
  applications: {
    title: 'Ozon-Anwendungen',
    subtitle: 'Lösungen für jeden Bedarf',
    tabHome: 'Zuhause',
    tabB2B: 'B2B',
    home: {
      title: 'Für Ihr Zuhause',
      description: 'Natürliche Desinfektion für häusliche Umgebungen',
    },
    hotel: {
      title: 'Hotel & Gastgewerbe',
      description: 'Professionelle Hygiene für Zimmer und Gemeinschaftsbereiche',
    },
    laundry: {
      title: 'Wäschereien',
      description: 'Ökologisches und effektives Waschen',
    },
    b2b: {
      title: 'B2B-Lösungen',
      description: 'Technologie für Unternehmen und Fachleute',
    },
    discoverProducts: 'Produkte entdecken',
  },
  
  // Products
  products: {
    title: 'Unsere Produkte',
    subtitle: 'Zertifizierte Technologie für jeden Bedarf',
    cta: 'Mehr erfahren',
  },
  
  // Resources
  resources: {
    title: 'Kostenlose Ressourcen',
    subtitle: 'Laden Sie Leitfäden, Checklisten und Bildungsmaterialien für sicheren Ozongebrauch herunter',
    checklist: {
      title: 'Sicherheits-Checkliste',
      description: 'Vollständige Liste der Kontrollen vor, während und nach jeder Behandlung.',
      cta: 'PDF herunterladen',
    },
    guide: {
      title: 'Schnell-Leitfaden O₃',
      description: 'Praktisches Handbuch mit allem, was Sie für einen sicheren Start wissen müssen.',
      cta: 'PDF herunterladen',
    },
    poster: {
      title: 'Informationsposter',
      description: 'A4-Poster zum Ausdrucken mit den goldenen Regeln für sicheren Ozongebrauch.',
      cta: 'PDF herunterladen',
    },
  },
  
  // Blog
  blog: {
    title: 'Bildung & Sicherheit',
    subtitle: 'Artikel, Leitfäden und Einblicke über Ozon',
    comingSoon: 'Inhalte kommen bald',
    comingSoonDesc: 'Wir bereiten ausführliche Artikel und Leitfäden für Sie vor. Schauen Sie bald wieder vorbei!',
    cta: 'Newsletter abonnieren',
  },
  
  // AI Assistant
  ai: {
    badge: 'Fortgeschrittener KI-Assistent',
    title: 'Ihr O₃ Sicherheits-Coach',
    titleHighlight: 'Sicherheits-Coach',
    subtitle: 'Ein intelligenter Assistent, der Ihnen immer zur Seite steht, um alle Fragen zu Ozon, Anwendungssicherheit und Best Practices zu beantworten. Chat oder Stimme, wann immer Sie wollen.',
    features: {
      friendly: {
        title: 'Freundlich & Klar',
        description: 'Einfache und verständliche Antworten, ohne unnötigen Fachjargon',
      },
      responsible: {
        title: 'Verantwortungsbewusst',
        description: 'Sicherheitsleitplanken: keine medizinischen Versprechen, nur validierte Informationen',
      },
      knowledge: {
        title: 'Wissensdatenbank',
        description: 'Zugriff auf alle Leitfäden, FAQs und Checklisten der Website',
      },
      available: {
        title: 'Immer Verfügbar',
        description: 'Chat und Stimme, 24/7, um Ihre Fragen zu beantworten',
      },
    },
    ctaCard: {
      title: 'Sind Sie bereit, Fragen zu stellen?',
      description: 'Klicken Sie auf die türkisfarbene Schaltfläche unten rechts, um ein Gespräch zu beginnen. Sie können dem Coach schreiben oder direkt mit ihm sprechen.',
      cta: 'KI-Coach öffnen',
    },
    examplesTitle: 'Oder versuchen Sie es mit einer dieser Fragen:',
    question1: 'Wie funktioniert Ozon?',
    question2: 'Ist es sicher für mein Zuhause?',
    question3: 'Wie lange sollte ich lüften?',
    question4: 'Kann ich es mit Haustieren verwenden?',
    question5: 'Welche Konzentrationen sind sicher?',
    question6: 'Wie desinfiziere ich Textilien?',
    safetyNotice: {
      title: 'Wichtiger Sicherheitshinweis',
      description: 'Der KI-Coach bietet Bildungsinformationen auf der Grundlage von Standards und wissenschaftlicher Forschung. Er bietet keine medizinische oder therapeutische Beratung an. Bei klinischen oder gesundheitlichen Fragen wenden Sie sich bitte immer an einen qualifizierten Fachmann. Der Coach wird Sie zu den richtigen Ressourcen führen.',
    },
  },
  
  // About
  about: {
    title: 'Über uns',
    subtitle: 'Purevital / OzoneFusion',
    mission: 'Unsere Mission',
    missionText: 'Ozon-Technologie für alle zugänglich, sicher und verständlich machen. Wir glauben an eine sauberere Zukunft durch Bildung und verantwortungsvolle Innovation.',
    values: 'Unsere Werte',
    value1: 'Wissenschaftliche Transparenz',
    value2: 'Sicherheit zuerst',
    value3: 'Umweltverträglichkeit',
    value4: 'Verantwortungsvolle Innovation',
  },
  
  // Contact
  contact: {
    title: 'Kontaktieren Sie uns',
    subtitle: 'Wir sind hier, um Ihre Fragen zu beantworten',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    message: 'Nachricht',
    send: 'Nachricht senden',
    whatsapp: 'Schreiben Sie uns auf WhatsApp',
    emailUs: 'Senden Sie uns eine E-Mail',
    newsletter: 'Newsletter abonnieren',
    newsletterDesc: 'Erhalten Sie Updates, Leitfäden und Sicherheitstipps',
    subscribe: 'Abonnieren',
    success: 'Nachricht erfolgreich gesendet!',
    error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
  },
  
  // Footer
  footer: {
    tagline: 'Bildung, Sicherheit und Technologie für eine sauberere Zukunft',
    explore: 'Erkunden',
    education: 'Bildung',
    company: 'Unternehmen',
    support: 'Support',
    legal: 'Rechtliches',
    contactUs: 'Kontaktieren Sie uns',
    faq: 'FAQ',
    guides: 'Sicherheit und Richtlinien',
    community: 'Gemeinschaft',
    privacy: 'Datenschutzrichtlinie',
    cookies: 'Cookie-Richtlinie',
    disclaimer: 'Haftungsausschluss',
    terms: 'Allgemeine Geschäftsbedingungen',
    allProducts: 'Alle Produkte',
    compareProducts: 'Produkte vergleichen',
    rights: 'Alle Rechte vorbehalten',
    poweredBy: 'Powered by Readdy',
  },
  
  // Common
  common: {
    readMore: 'Mehr lesen',
    learnMore: 'Mehr erfahren',
    download: 'Herunterladen',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    loading: 'Laden...',
  },
};
